var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main',{attrs:{"role":"main"}},[_c('div',{staticClass:"content-safe-space"},[_vm._t("default")],2)]),_vm._v(" "),_c('Modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }